module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1157.1c6d9ec3.png";